import { IBase } from "./base";
import {
  getSlugId,
} from '../utilities/model-utils';

export interface IOrganization extends IBase {
  business_name?: string;
  business_phone?: string;
  business_address?: string;
  business_city?: string;
  business_state?: string;
  business_postal_code?: string;
  business_country?: string;
  org_user_first_name?: string;
  org_user_last_name?: string;
  org_user_email?: string;
  enable_order_sms: boolean;
  name: string;
  olo_brand?: string;
  olo_brand_details: Record<string, unknown>;
  olo_shared_secret?: string;
}

export class Organization implements IOrganization {
  public name: string;
  public business_name?: string;
  public business_phone?: string;
  public business_address?: string;
  public business_city?: string;
  public business_state?: string;
  public business_postal_code?: string;
  public business_country?: string;
  public org_user_first_name?: string;
  public org_user_last_name?: string;
  public org_user_email?: string;
  public enable_order_sms: boolean;
  public olo_brand?: string;
  public olo_shared_secret?: string;
  public olo_brand_details: Record<string, unknown>;
  public id: string;

  public constructor(args: IOrganization) {
    this.name = args.name;
    this.business_name = args.business_name;
    this.business_phone = args.business_phone;
    this.business_address = args.business_address;
    this.business_city = args.business_city;
    this.business_state = args.business_state;
    this.business_postal_code = args.business_postal_code;
    this.business_country = args.business_country;
    this.org_user_first_name = args.org_user_first_name;
    this.org_user_last_name = args.org_user_last_name;
    this.org_user_email = args.org_user_email;
    this.enable_order_sms = args.enable_order_sms;
    this.olo_brand = args.olo_brand;
    this.olo_shared_secret = args.olo_shared_secret;
    this.olo_brand_details = args.olo_brand_details;
    this.id = args.id;
    if (!this.id) {
      this.id = getSlugId();
    }
  }

  static create(args: IOrganization): Organization {
    return new this(args);
  }
}
